import axios from "axios";
import { getToken } from '@/util/token-util.js'

// 兼容 https：跟随当前页面协议，避免混合内容拦截
const API_ROOT = `${window.location.protocol}//158aaa.com`
// const API_ROOT = 'https://yinlv-dx.zhiqiyf.com'
const API_BASE = `${API_ROOT}/api`

function buildApiUrl(url = '') {
	const apiPath = String(url || '').replace(/^\/+/, '')
	return apiPath ? `${API_BASE}/${apiPath}` : API_BASE
}

const axios_ins_common = axios.create({
	// baseURL: 'https://rblxzz.cn',
	// baseURL: "",
	timeout: 60000,
	headers: {
		Accept: "application/json",
	},
});

function buildAuthHeaders() {
	const token = getToken();

	return token
		? {
			Authorization: `Bearer ${token}`,
		}
		: {};
}

// 响应拦截器
axios_ins_common.interceptors.response.use(
	function (res) {
		let data = res.data;
		if (data.code == 403 || data.code == 401) {
			return Promise.reject(data);
		}
		return data;
	},
	function (error) {
		console.log("api res 失败拦截", error);
		return Promise.reject(error);
	}
);

function api(option) {
	let url = option.url;
	let method = option.method || 'get';
	let data = option.data;
	url = buildApiUrl(url)

	let request_data = {
		...data,
		token: getToken(),
	};

	let otherConfig = {
		headers: {
			Accept: "application/json",
			"Content-Type": "application/x-www-form-urlencoded",
			...buildAuthHeaders(),
		},
		transformRequest: [
			function (data) {
				let ret = "";
				let items = []
				for (let key in data) {
					let str = encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
					items.push(str)
				}
				ret = items.join('&')
				return ret;
			},
		]
	};

	if (method == "get") {
		return axios_ins_common({
			url: url,
			method: method,
			params: request_data,
			...otherConfig,
		});
	} else {
		return axios_ins_common({
			url: url,
			method: method,
			data: request_data,
			...otherConfig,
		});
	}
}

// 文件上传
export function uploadApi(formData, action = 'Common/uploadFile') {
	const token = getToken();

	if (token && !formData.has('token')) {
		formData.append('token', token);
	}

	let url = buildApiUrl(action)
	return axios({
		url,
		method: 'post',
		headers: {
			Accept: "application/json",
			...buildAuthHeaders(),
			"Content-Type": "multipart/form-data;boundary=" + new Date().getTime(),
		},
		transformRequest: [],
		data: formData,
		// params
	});
}

export default api
